import { createSelector } from 'reselect';

const getDiagnosisUsers = state => state.hairDiagnosis.users;
const getUserId = (_, props) => props.match.params.id || undefined;

export const getDiagnosisUser = createSelector([getDiagnosisUsers, getUserId], (users, id) => {
  if (id) {
    const currentUserId = Object.keys(users).find(userId => users[userId].hash === id);
    if (currentUserId) {
      return {
        ...users[currentUserId],
        diagnosisResults: users[currentUserId].diagnosisResults.sort(
          (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
        ),
      };
    }
  }
  return users.temporary;
});

export const getCurrentDiagnosisUser = createSelector([getDiagnosisUsers], users => {
  const currentUserId = Object.keys(users).find(userId => users[userId].current);
  return currentUserId ? users[currentUserId] : null;
});

export const getAllDiagnosisUsers = createSelector([getDiagnosisUsers], users =>
  Object.keys(users).map(userId => users[userId])
);



// WEBPACK FOOTER //
// ./src/redux/selectors/hairDiagnosis.js